@if (useRecoveryCode()) {
  <input
    class="input-main w-full h-12 text-center text-xl uppercase tracking-widest rounded-md border border-ui-gray-light"
    (input)="onRecoveryCodeInput($event)"
    [class.border-ui-red-300]="invalid()"
    [value]="recoveryCode()"
    data-testid="recovery-code-input"
    maxlength="9"
    placeholder="XXXX-XXXX"
  />
} @else {
  @for (digit of digits(); track $index) {
    <input
      class="input-main w-12 h-12 text-center text-xl rounded-md border focus-within:border-black focus-within:border-2 outline-none"
      (focus)="onDigitFocus($event)"
      (input)="onDigitInput($index, $event)"
      (keydown)="onDigitKeydown($index, $event)"
      (paste)="onDigitPaste($event)"
      [class.border-ui-red-50]="invalid()"
      [class.mr-2]="$index === 2"
      [value]="digit"
      #digitInput
      inputmode="numeric"
      maxlength="1"
    />
  }
}
